import { useCallback, useMemo, useState } from 'react';
import ErrorModalContext from './ErrorModalContext';
import { Outlet } from 'react-router-dom';
import ErrorModal from '../components/reusable/ErrorModal';
import { AxiosError } from 'axios';

function ErrorModelContextProvider() {
  const [errorMessage, setErrorMessage] = useState<string | string[]>('');
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback((errorMessage: string | string[], error: Error | AxiosError) => {
    setErrorMessage(errorMessage);
    setIsOpen(true);
    console.error(error.message);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = useMemo(
    () => ({ errorMessage, isOpen, handleOpen, handleClose }),
    [errorMessage, isOpen, handleOpen, handleClose]
  );

  return (
    <ErrorModalContext.Provider value={value}>
      <ErrorModal />
      <Outlet />
    </ErrorModalContext.Provider>
  );
}

export default ErrorModelContextProvider;
